module.exports = __webpack_public_path__ + "static/media/briefcase-medical.e3ec9faf.svg";